import { ref } from "vue";
import Vue from "vue-ltur";
var FormFieldValidator = /** @class */ (function () {
    function FormFieldValidator() {
        this.formFieldMap = new Map();
    }
    FormFieldValidator.prototype.setIfEmpty = function (key) {
        if (!this.formFieldMap.has(key)) {
            this.formFieldMap.set(key, {
                error: ref(false),
                valid: ref(false),
                message: ref("")
            });
        }
    };
    FormFieldValidator.prototype.clear = function () {
        this.formFieldMap.clear();
    };
    FormFieldValidator.prototype.reset = function () {
        this.formFieldMap.forEach(function (data) {
            data.valid.value = false;
            data.error.value = false;
            data.message.value = "";
        });
    };
    FormFieldValidator.prototype.has = function (key) {
        return this.formFieldMap.has(key);
    };
    FormFieldValidator.prototype.update = function (key, data) {
        this.setIfEmpty(key);
        this.formFieldMap.get(key).valid.value = data.valid;
        this.formFieldMap.get(key).error.value = data.error;
        this.formFieldMap.get(key).message.value = Vue.translate(data.message);
    };
    FormFieldValidator.prototype.read = function (key) {
        this.setIfEmpty(key);
        return this.formFieldMap.get(key);
    };
    return FormFieldValidator;
}());
export { FormFieldValidator };
